import React from "react";
import { Trash2 } from "lucide-react";

export default function ButtonLimpar({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 bg-[#b50000] text-white px-4 py-2 shadow-md transition-transform duration-200 hover:scale-105"
      style={{
        borderRadius: "0px",
        fontFamily: "Comfortaa, cursive",
        fontWeight: 600,
        fontSize: "15px",
      }}
    >
      <Trash2 size={18} />
      Limpar Filtros
    </button>
  );
}
